import { Icon, SvgBack5 } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function StepBackFiveButton(props) {
  return (
    <ControlBarButton
      className={classNames('step-back-five-button', {
        'crowded-embed': props.crowded && !props.isMainVideoOnSharePage,
      })}
      hoverTagText="Step Back (j)"
      seeking={props.seeking}
      onClick={props.onClick}
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgBack5 />}
      />
    </ControlBarButton>
  );
}
